import unitTexts from "@/wl-unit-text/UnitTexts";
import unitIcons from "@/wl-unit-text/UnitIcons";

export default function () {
    let keywords = unitTexts;
    let defaultKeyword = 'lifts'
    let defaultIcon = unitIcons.lifts

    const replaceIcon = (type) => {
        return unitIcons[type] || defaultIcon
    }

    const hasUpperCase = (text) => {
        let firstLetter = text.substring(0, 1)
        return (firstLetter === firstLetter.toUpperCase())
    }
    const isAllUpperCase = (text) => {
        let capitalisedText = text.toUpperCase();
        return capitalisedText === text
    }
    const replaceText = (text, type) => {
        if (type === defaultKeyword) return text;
        let generatedText = text
        let toReplace = text.trim()
        let keyword = text.toLowerCase();
        if (keywords[type][keyword] !== undefined) {
            generatedText = keywords[type][keyword]
            if (hasUpperCase(text) && !isAllUpperCase(text)) {
                generatedText = generatedText.charAt(0).toUpperCase() + generatedText.slice(1);
            } else if (isAllUpperCase(text)){
                generatedText = generatedText.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
            }
            generatedText = text.replace(toReplace,generatedText)
        }
        return generatedText;
    }
    return {
        replaceText, replaceIcon, defaultKeyword
    }

}